import { supportedLanguages } from "@/i18n/constants";

// フッターのダミーリンク先ページ一覧。`/docs/:lng/:page.html` (index.ts の docsRoute) と
// Footer.tsx の双方から参照するため共通化する。
export const docsPages = [
  "privacy-policy",
  "terms-of-service",
  "specified-commercial-transactions",
  "faq",
] as const;

export type DocsPage = (typeof docsPages)[number];

// フォールバック言語 (実コンテンツが用意されていない言語・未サポート言語でアクセスされた
// 場合のデフォルト)。
const FALLBACK_LANGUAGE = "en";

// 各ページで実コンテンツが用意されている言語。ここに記載のないページは制限なし
// (supportedLanguages 全体で同一挙動) とする (JPTP_CANSEI-1350)。
const AVAILABLE_LANGUAGES: Partial<Record<DocsPage, readonly string[]>> = {
  "privacy-policy": ["en"],
  "terms-of-service": ["en"],
  "specified-commercial-transactions": ["en", "ja"],
  faq: ["en", "ja"],
};

// 指定言語に実コンテンツがない場合、または supportedLanguages に含まれない未サポート言語
// の場合は FALLBACK_LANGUAGE を返す。戻り値は必ず `public/docs/*` のディレクトリ名
// (supportedLanguages のいずれか) に一致する。
export function resolveDocsLanguage(page: DocsPage, lng: string): string {
  if (!supportedLanguages.includes(lng as (typeof supportedLanguages)[number])) {
    return FALLBACK_LANGUAGE;
  }
  const available = AVAILABLE_LANGUAGES[page];
  if (!available || available.includes(lng)) {
    return lng;
  }
  return FALLBACK_LANGUAGE;
}
